import type { JSX } from 'react';

export type ComponentByScreen = Record<DrawerScreen, () => JSX.Element>;

export enum DrawerScreen {
  OTHER_PAYMENT_METHOD = 'otherPaymentMethod',
  SAVED_CARDS = 'savedCards',
  NEW_CARD = 'newCard',
}
